import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../../../../../util/state/GlobalContextProvider";
import FormDatePicker from "../../../experiments/forms/FormDatePicker";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

interface Props {
    open: boolean;
    form?: any;
    title: string,
    body: string,
    leftButton: string,
    rightButton: string,
    viewNote?: boolean,
    leftFunction: () => void,
    rigthFunction: () => void,
    onClose: () => void;
}

const CollectionsModal = (props: Props) => {
    const { t } = useTranslation("finance", { keyPrefix: "sdd.collections" });
    const { dispatchGlobalData } = useContext(GlobalContext);

    const schema = Yup.object().shape({
        collectionDate: Yup.date()
          .min(new Date(), t('modal.errors.invalid-collection-date'))
          .required(t('modal.errors.invalid-collection-date-required'))
      });



    const { handleSubmit, control, register, setValue } = useForm<any>({
        defaultValues: {
            collectionDate: props.form.currentRow.receiptDate
        },
        resolver: yupResolver(schema)
    });

    
    console.log(props.form);

    const navigate = useNavigate();
    const onClose = () => {
        props.onClose();
    };



    const onSubmit: SubmitHandler<any> = (data) => {
        console.log(data)
        let id = props.form.currentRow.id;

        //let mandateStatus = { id: props.form.id, status: props.form.status, notes: data.notes };
        /*         putMandateStatus(mandateStatus).then(() => {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: props.form.status === STATUS_REVOKED ? t('snackbar.success-revoke') : t('snackbar.success-delete'),
                                type: snackbarTypes.success,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                }).catch(() => {
                    dispatchGlobalData({
                        type: setSnackbar,
                        payload: {
                            snackbar: {
                                message: props.form.status === STATUS_REVOKED ? t('snackbar.error-revoke'): t('snackbar.success-delete'),
                                type: snackbarTypes.error,
                                show: true,
                                autoClose: true
                            }
                        }
                    });
                });
                navigate(-1); */
    }

    return (
        <Mui.Dialog
            open={props.open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    minWidth: "600px !important",
                    minHeight: "194px",
                    borderRadius: "4px",
                },
            }}
        >
            <Mui.DialogTitle>
                <Mui.Grid
                    container
                    alignItems="center"
                    alignContent="center"
                    direction="row"
                >
                    <Mui.Grid xs item>
                        <Mui.Stack direction="row" alignItems="center" gap={1}>
                            <MuiIcons.Info sx={{ color: '#C8017D' }} fontSize="small" />
                            <Mui.Box >{props.title}</Mui.Box>
                        </Mui.Stack>
                    </Mui.Grid>
                    <Mui.Grid
                        xs
                        item
                        sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                        }}
                    >
                        <MuiIcons.Close
                            color="disabled"
                            fontSize="small"
                            onClick={onClose}
                        />
                    </Mui.Grid>
                </Mui.Grid>
            </Mui.DialogTitle>




            <form onSubmit={handleSubmit(onSubmit)}>
                <Mui.Grid>

                    <Mui.DialogContent>
                        <Mui.DialogContentText>
                            {props.body}

                            {props.viewNote &&
                                <Mui.Grid container>
                                    <Mui.Grid item xs="auto" style={{ marginTop: 26 }}>
                                        <Mui.Typography variant="h6">
                                            {t('modal.labels.editCollectionDate')}
                                        </Mui.Typography>
                                    </Mui.Grid>
                                    <Mui.Grid item xs={12}>
                                        <FormDatePicker
                                            name={"collectionDate"}
                                            control={control}
                                            props={{
                                                label: t('modal.labels.collectionDate'),
                                                //maxDate: watcher.validDateTo || undefined
                                            }}
                                        />
                                    </Mui.Grid>
                                </Mui.Grid>
                            }



                        </Mui.DialogContentText >
                        <Mui.Grid item xs="auto" style={{ marginTop: 26 }}>
                            <Mui.DialogContentText>
                                {t('modal.download.collectionBodyMessage-note')}
                            </Mui.DialogContentText>
                        </Mui.Grid>

                    </Mui.DialogContent>
                    <Mui.DialogActions>
                        <Mui.Stack direction="row" spacing={2} p={1} mr={1}>
                            <Mui.Button
                                sx={{
                                    maxWidth: "111px",
                                    maxHeight: "48px",
                                    minWidth: "111px",
                                    minHeight: "48px",
                                }}
                                variant="outlined"
                                onClick={props.leftFunction}
                            >
                                <Mui.Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: 700,
                                        lineHeight: 1.25,
                                        color: "#C8017D",
                                    }}
                                    variant="subtitle1"
                                >
                                    {props.leftButton}
                                </Mui.Typography>
                            </Mui.Button>

                            <Mui.Button
                                sx={{
                                    maxWidth: "181px",
                                    maxHeight: "48px",
                                    minWidth: "111px",
                                    minHeight: "48px",
                                }}
                                type={props.viewNote ? 'submit' : 'button'}
                                variant="contained"
                                color="accent"
                                onClick={props.rigthFunction}
                            >
                                <Mui.Typography
                                    sx={{
                                        textTransform: "capitalize",
                                        fontWeight: 700,
                                        lineHeight: 1.25,
                                        color: 'white'
                                    }}
                                    variant="subtitle1"
                                >
                                    {props.rightButton}
                                </Mui.Typography>
                            </Mui.Button>
                        </Mui.Stack>
                    </Mui.DialogActions>
                </Mui.Grid>
            </form>



        </Mui.Dialog>

    );
}

export default CollectionsModal;